import '../styles/main.sass'
import '@/lib/select.js'
import Loader from '@/utils/loader.js'
import Modal from '@/utils/modal.js'
import SearchModal from '@/utils/search-modal.js'
import lazysizes from 'lazysizes'
import app from '@/app.js'
import router from '@/router.js'
import { fetchCart } from '@/lib/cart.js'
// import { enableBodyScroll, disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock'

// selectors
const wrapper = document.getElementById('wrapper')
const cart_content = document.getElementById('custom-cart-content')
const loader = new Loader()
const modal = new Modal()
const search_modal = new SearchModal()

// ref to router
app.hydrate({ router: router })

// navigation start
document.addEventListener('pjax:send', (e) => {
  // here we go
  wrapper.classList.add('pjaxin')
  modal.suspendModal()
  search_modal.suspendSearchModal()
  loader.activateLoader()

  // we're in PJAX mode
  app.hydrate({ pjax: true })

})

// navigation success
document.addEventListener('pjax:success', (e) => {
  let path = window.location.pathname

  app.unmount()
  app.mount()
  app.hydrate({ loadURL: '' })
})

// navigation complete
document.addEventListener('pjax:complete', (e) => {
  // good to go
  wrapper.classList.remove('pjaxin')
  loader.suspendLoader()
})

//
// Cart toggle
//
app.on('cart:toggle', ({cart, cartOpen}) => {
  app.hydrate({ cart })

  if (cartOpen === true) {
    cart_content.offsetHeight;
    cart_content.scrollTop = 0
    document.body.classList.remove('open-menu')
    document.body.classList.add('cart-open')
    document.body.classList.add('lock')
  } else {
    document.body.classList.remove('open-menu')
    document.body.classList.remove('cart-open')
    document.body.classList.remove('lock')
  }
})

//
// load any data that your site needs on first load
//
Promise.all([
  fetchCart(),
  loader.resetLoader()
]).then(([ cart ]) => {
  setTimeout(() => {
    loader.suspendLoader()
  }, 666)
  //
  // add the cart data to the picoapp instance
  //
  app.hydrate({ cart })
  //
  // mount any components defined on the page
  //
  app.mount()
})
